module.exports = "https://img.xiyuyouxi.com/saas/img/mine_menu4.417b5053.png";